import { render, staticRenderFns } from "./CoursewareListContainer.vue?vue&type=template&id=bda4c016&"
import script from "./CoursewareListContainer.vue?vue&type=script&lang=js&"
export * from "./CoursewareListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports